import CNEnum from "@src/Locales/Constants/CNEnum";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import AreaCode from "@src/assets/international/AreaCode.json";

const useContactOpts = () => {
  const { t, i18n } = useTranslation();
  const chainOptions = useMemo(() => {
    return [
      {
        label: t(CNEnum.yesLabel),
        value: "CHAIN",
      },
      {
        label: t(CNEnum.noLabel),
        value: "SINGLE",
      },
    ];
  }, [i18n.language]);

  const businessTypeOptions = useMemo(() => {
    return [
      // 快餐
      {
        label: t(CNEnum.fastFood),
        value: "0",
      },
      // 茶饮
      {
        label: t(CNEnum.teaDrink),
        value: "1",
      },
      // 正餐
      {
        label: t(CNEnum.dinner),
        value: "2",
      },
      // 酒吧
      {
        label: t(CNEnum.bar),
        value: "3",
      },
      // 综合
      {
        label: t(CNEnum.comprehensive),
        value: "4",
      },
      // 咖啡厅
      {
        label: t(CNEnum.cafeLabel),
        value: "5",
      },
      // 烘焙
      {
        label: t(CNEnum.bakingShop),
        value: "6",
      },
      // 麻辣烫
      {
        label: t(CNEnum.Malatang),
        value: "7",
      },
      // 火锅
      {
        label: t(CNEnum.Hotpot),
        value: "8",
      },
      // 烧烤
      {
        label: t(CNEnum.BBQ),
        value: "9",
      },
      // 中式自助餐
      {
        label: t(CNEnum.ChineseBuffet),
        value: "10",
      },
      // 西式自助餐
      {
        label: t(CNEnum.WesternStyleBuffet),
        value: "11",
      },
      // 团餐/食堂
      {
        label: t(CNEnum.GroupMealsCafeteria),
        value: "12",
      },
      // 大正餐
      {
        label: t(CNEnum.GrandMeal),
        value: "13",
      },
      // 零售
      {
        label: t(CNEnum.Retail),
        value: "14",
      },
    ];
  }, [i18n.language]);

  const businessStatusOpts = useMemo(() => {
    return [
      {
        label: t(CNEnum.contactInBusiness),
        value: "BUSINESS",
      },
      {
        label: t(CNEnum.contactPrepareProgress),
        value: "PREPARING",
      },
    ];
  }, [i18n.language]);

  const understandChannels = useMemo(() => {
    return [
      {
        label: t(CNEnum.understandChannelsSocial),
        value: "1",
      },
      {
        label: t(CNEnum.understandChannelsSearch),
        value: "2",
      },
      {
        label: t(CNEnum.understandChannelsSeeBusinessRes),
        value: "3",
      },
      {
        label: t(CNEnum.understandChannelsRecommendByFriend),
        value: "4",
      },
    ];
  }, [i18n.language]);

  return {
    chainOptions,
    businessTypeOptions,
    AreaCode,
    businessStatusOpts,
    understandChannels,
  };
};

export default useContactOpts;
